// extracted by mini-css-extract-plugin
module.exports = {"SearchItemLink":"SearchItem_SearchItemLink__n2cD_","SearchItem":"SearchItem_SearchItem__1YeFd"};